import { useSessionStore } from '@/stores/SessionStore.ts';
import type { CreateCheckoutSessionResponseDto } from '../../../@generated/api-client';
import { apiService } from '@/services/ApiService.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';

export const startSubscriptionProcessAction = async () => {
    const sessionStore = useSessionStore();
    sessionStore.isFullLoading = true;

    let apiResponse: CreateCheckoutSessionResponseDto;
    try {
        apiResponse = await apiService.getApi().stripeCreateCheckoutSessionV1();
    } catch {
        sessionStore.isFullLoading = false;

        createTextToast(
            'Failed to connect to payment provider',
            'Please try again later',
            'destructive',
            false,
        );

        return;
    }

    sessionStore.isFullLoading = false;

    window.open(apiResponse.url, '_blank');
};
